NotificationMetricsStateEnum
<template>
  <MetricCard
    data-id="metrics-notifications"
    :data-state="state"
    :label="label"
    hover="View notifications"
    title="Notifications"
    :status="status"
    :loading="loading"
    @click="onClick"
  />
</template>
<script setup lang="ts">
import MetricCard from '../MetricCard.vue';
import { onMounted, ref } from 'vue';

import { loadFetch } from '../../../lib/services/helpers';
import { useStore3 } from '../../../store/main';
import { storeToRefs } from 'pinia';
import {
  NotificationMetricsStateEnum,
  NotificationMetricsStatusEnum,
} from '@mailslurp/admin-sdk';
import { navigateTo, computed } from '#imports';

const store3 = useStore3();
const loading = ref(false);

const { metricsNotifications } = storeToRefs(store3);
const state = computed<NotificationMetricsStateEnum>(
  () => metricsNotifications.value?.state ?? NotificationMetricsStateEnum.OKAY,
);
const label = computed(() =>
  state.value === NotificationMetricsStateEnum.HAS_NOTIFICATIONS
    ? 'Notification'
    : '',
);
const status = computed<NotificationMetricsStatusEnum>(
  () =>
    metricsNotifications.value?.status ?? NotificationMetricsStatusEnum.SUCCESS,
);
const onClick = async () => {
  await navigateTo('/notifications/');
};
onMounted(async () => {
  await loadFetch(() => store3.getMetricsNotifications(), store3, loading);
});
</script>
